(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      this.remove();
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carosello-4-section"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  class ScrollLockHero {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.scroll-lock-hero__slide');
      this.indicators = container.querySelectorAll('.scroll-lock-hero__indicator');
      
      this.currentSlide = 0;
      this.totalSlides = this.slides.length;
      this.isAnimating = false;
      this.slidesSeen = new Set();
      this.lastScrollTime = 0;
      this.scrollDelay = 800;
      this.startX = 0;
      this.touchThreshold = 50;
      this.allSlidesSeen = false;

      this.init();
    }

    init() {
      this.slides[0].classList.add('is-active');
      this.indicators[0].classList.add('is-active');
      this.slidesSeen.add(0);

      this.container.addEventListener('click', (e) => this.handleIndicatorClick(e));
      document.addEventListener('keydown', (e) => this.handleKeyboard(e));
      this.container.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
      this.container.addEventListener('touchend', (e) => this.handleTouchEnd(e), false);
      window.addEventListener('wheel', (e) => this.handleWheel(e), { passive: false });

      document.documentElement.style.overflow = 'hidden';
    }

    showSlide(index) {
      if (index < 0 || index >= this.totalSlides) return;
      if (this.isAnimating) return;

      this.isAnimating = true;

      this.slides.forEach(slide => slide.classList.remove('is-active'));
      this.indicators.forEach(ind => ind.classList.remove('is-active'));

      this.slides[index].classList.add('is-active');
      this.indicators[index].classList.add('is-active');
      this.currentSlide = index;
      this.slidesSeen.add(index);

      // Controlla se hai visto tutte le slide
      if (this.slidesSeen.size === this.totalSlides) {
        this.allSlidesSeen = true;
      }

      setTimeout(() => {
        this.isAnimating = false;
      }, 800);
    }

    nextSlide() {
      if (this.currentSlide < this.totalSlides - 1) {
        this.showSlide(this.currentSlide + 1);
      } else if (this.allSlidesSeen) {
        // Nascondi la sezione hero
        this.hideSection();
      }
    }

    prevSlide() {
      if (this.currentSlide > 0) {
        this.showSlide(this.currentSlide - 1);
      }
    }

    hideSection() {
      this.container.classList.add('is-hidden');
      document.documentElement.style.overflow = 'auto';
    }

    handleWheel(e) {
      const now = Date.now();
      if (now - this.lastScrollTime < this.scrollDelay) return;

      this.lastScrollTime = now;

      if (!this.allSlidesSeen) {
        // Non hai visto tutte, blocca scroll
        e.preventDefault();
        if (e.deltaY > 0) {
          this.nextSlide();
        } else if (e.deltaY < 0) {
          this.prevSlide();
        }
      } else if (this.currentSlide === this.totalSlides - 1 && e.deltaY > 0) {
        // Tutte viste, ultimo slide, scorri giù
        this.hideSection();
      }
    }

    handleKeyboard(e) {
      if (e.key === 'ArrowRight') {
        this.nextSlide();
      } else if (e.key === 'ArrowLeft') {
        this.prevSlide();
      }
    }

    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
    }

    handleTouchEnd(e) {
      const endX = e.changedTouches[0].clientX;
      const diff = this.startX - endX;

      if (Math.abs(diff) > this.touchThreshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    }

    handleIndicatorClick(e) {
      if (e.target.closest('.scroll-lock-hero__indicator')) {
        const button = e.target.closest('.scroll-lock-hero__indicator');
        const index = parseInt(button.dataset.slideIndex);
        this.showSlide(index);
      }
    }
  }

  function initScrollLockHero() {
    document.querySelectorAll('[data-section-type="scroll-lock-hero"]:not([data-initialized])').forEach(container => {
      container.dataset.initialized = 'true';
      new ScrollLockHero(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollLockHero);
  } else {
    initScrollLockHero();
  }

  document.addEventListener('shopify:section:load', initScrollLockHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-griglia-galleria"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('pvg-gallery')) return;

    class PvgGallery extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this.track = this.querySelector('[data-pvg-track]');
        if (!this.track) return;
        this._ready = true;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-pvg-dot]'));
        this.prev = this.querySelector('[data-pvg-prev]');
        this.next = this.querySelector('[data-pvg-next]');
        this.index = 0;

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this._raf);
          this._raf = requestAnimationFrame(() => {
            const w = this.track.clientWidth || 1;
            const i = Math.round(this.track.scrollLeft / w);
            if (i !== this.index) { this.index = i; this.update(); }
          });
        }, { passive: true });

        if (this.prev) this.prev.addEventListener('click', (e) => { e.preventDefault(); this.go(this.index - 1); });
        if (this.next) this.next.addEventListener('click', (e) => { e.preventDefault(); this.go(this.index + 1); });
        this.dots.forEach((dot, i) => dot.addEventListener('click', (e) => { e.preventDefault(); this.go(i); }));

        this.update();
      }

      go(i) {
        const last = this.slides.length - 1;
        const target = Math.max(0, Math.min(last, i));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = this.index <= 0;
        if (this.next) this.next.disabled = this.index >= this.slides.length - 1;
      }
    }

    customElements.define('pvg-gallery', PvgGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
